import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ESIGN_DATA_SITE_ID, ESIGN_DATA_SITE_ID_NEW, ESIGN_SCRIPT_URL, ESIGN_SCRIPT_URL_NEW, ESIGN_REDIRECTION_TOKEN } from "utilities/Constant";
import { useGetFeatureFlagsQuery } from "services/common/featureFlagService";

export interface ElectronicSignatureProps {
  loanAccessToken?: string;
  packageId?: string;
  /** Fires when the vendor e-sign script URL has finished loading (not signing completion). */
  onScriptLoad?: () => void;
  /** Fires when the vendor e-sign script fails to load. */
  onScriptError?: () => void;
}

const ElectronicSignature: React.FC<ElectronicSignatureProps> = ({ loanAccessToken, packageId, onScriptLoad, onScriptError }) => {
  const eSignRedirectionToken = localStorage.getItem(ESIGN_REDIRECTION_TOKEN);
  const { data: featureFlags } = useGetFeatureFlagsQuery();
  const useNewESignWidget = featureFlags?.newESignWidgetEnabled;
  const eSignScriptUrl = useNewESignWidget ? ESIGN_SCRIPT_URL_NEW : ESIGN_SCRIPT_URL;
  const eSignDataSiteId = useNewESignWidget ? ESIGN_DATA_SITE_ID_NEW : ESIGN_DATA_SITE_ID;
  const navigate = useNavigate();
  useEffect(() => {
    if (eSignRedirectionToken) {
      const script = document.createElement("script");
      script.src = eSignScriptUrl;
      script.async = true;
      script.onload = () => {
        onScriptLoad?.();
      };
      script.onerror = () => {
        onScriptError?.();
      };

      document.body.appendChild(script);

      return () => {
        script.onload = null;
        script.onerror = null;
        script.remove();
      };
    } else {
      navigate("/post-auth", { replace: true });
    }
  }, [eSignRedirectionToken, eSignScriptUrl, navigate, onScriptLoad, onScriptError]);

  return (
    <div
      className="em-widget"
      data-testid="em-widget"
      data-width="100%"
      data-height="800px"
      data-min-height="800px"
      data-site-id={eSignDataSiteId}
      data-config={`{"authentication":"","token":"${loanAccessToken ?? ""}","packageId":"${packageId ?? ""}","externalLoginWindow":"true"}`}
      data-name="ecc-borrower-portal"
      data-aria-label="Borrower Portal"
    ></div>
  );
};

export default ElectronicSignature;
